// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"7025":"07469ea10a2382bb","8864":"0108de7919fb39b2"}[chunkId] + ".js";
};